import React, { useState, useEffect, useRef } from "react";
import { formatAmount } from "../../../utils/format.js";
import { axios_instance } from "../../../api/axios_instance.js";
import ContainerLoading from "../../../layouts/ContainerLoading.jsx";
import {
  decryptRequest,
  encryptRequest,
} from "../../../utils/encryptdecryptrequest.js";
import { ClickAwayListener, Portal } from "@mui/base";
import RTOCharges from "./RTOCharges.jsx";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const RTOSummary = ({ lead_id, caseDetails }) => {
  const detailsStore = useSelector((state) => state.details);
  const [rtoData, setRtoData] = useState({
    rtoDetails: [],
    rtoCharges: {},
    rcmHtml: "",
    toggleDocPopup: false,
    rtoSyncing: {
      status: false,
      rcTransferAmount: 0,
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const initialState = {
    showRtoChargeModal: false,
    leftPosition: 0,
    topPosition: 0,
  };
  const [rtoChargeState, setRtoChargeState] = useState(initialState);

  const openClickAwayListener = (name, buttonName) => {
    const button = document.querySelector(`.${buttonName}`);
    const rect = button.getBoundingClientRect();
    setRtoChargeState({
      ...rtoChargeState,
      [name]: !rtoChargeState[name],
      leftPosition: rect.left - rect.width / 4,
      topPosition: rect.top + 1.2 * rect.height,
    });
  };
  const changePosition = (name) => {
    const button = document.querySelector(`.${name}`);
    const rect = button.getBoundingClientRect();
    setRtoChargeState({
      ...rtoChargeState,
      leftPosition: rect.left - rect.width / 4,
      topPosition: rect.top + 1.2 * rect.height,
    });
  };

  useEffect(() => {
    const handleResize = () => {
      if (rtoChargeState.showRtoChargeModal)
        changePosition("rtoDetails-button");
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  let docCollected = "No";
  if (
    caseDetails.is_original_doc_verified &&
    caseDetails.is_original_doc_verified === 1
  ) {
    docCollected = "Yes";
  }

  const RSpan = () => <span className="fa fa-inr"></span>;

  useEffect(
    () => {
      const fetchData = async () => {
        setIsLoading(true);
        try {
          const reqData = encryptRequest({
            reg: caseDetails.regno.substring(0, 4),
            lead_id,
          });
          let rtoDetailsRes = await axios_instance({
            url: "/dts/getRTODetails",
            method: "POST",
            data: { reqData },
          });
          rtoDetailsRes = decryptRequest(rtoDetailsRes.data.resData);

          let rth = null;

          // Commented This - PB-2014
          // if (caseDetails.rcIssue === "Y") {
          rth = await axios_instance({
            url: "/dts/getRCMIssueList",
            method: "POST",
            data: { lead_id },
          });
          // }

          rtoDetailsRes.rtoCharges.total_charges =
            rtoDetailsRes.rtoCharges.total_charges -
            caseDetails.rto_convenience_fee;

          rtoDetailsRes.rtoCharges.total_invoice =
            rtoDetailsRes.rtoCharges.total_charges +
            rtoDetailsRes.rtoCharges.gst_charges +
            rtoDetailsRes.rtoCharges.tds_charges;

          setRtoData((prevState) => ({
            ...prevState,
            rtoDetails: rtoDetailsRes.result,
            rtoCharges: rtoDetailsRes.rtoCharges,
            rcmHtml: rth ? rth.data.result : "",
            rtoSyncing: {
              status: !!rtoDetailsRes.rtoSyncing?.status,
              rcTransferAmount: Number(
                rtoDetailsRes.rtoSyncing?.rcTransferAmount || 0,
              ),
              rcGstTdsCharges: Number(
                rtoDetailsRes.rtoSyncing?.gstTdsCharges || 0,
              ),
            },
          }));
        } catch (error) {
        } finally {
          setIsLoading(false);
        }
      };

      fetchData();
    },
    [
      // lead_id,
      // caseDetails.regno,
      // caseDetails.rcIssue,
      // caseDetails.rto_convenience_fee,
      // rtoData,
    ],
  );

  const ref = useRef(null);

  const toggleDocPopup = () => {
    setRtoData({ ...rtoData, toggleDocPopup: !rtoData.toggleDocPopup });
  };

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setRtoData((prevState) => ({ ...prevState, toggleDocPopup: false }));
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, []);

  const handleRTOChargeSync = async () => {
    toast.dismiss();
    try {
      // console.log({ caseDetails, rtoData });
      setIsLoading(true);
      const reqData = encryptRequest({
        lead_id,
        rto_amount: rtoData.rtoSyncing.rcTransferAmount,
        disbursement_id: caseDetails?.id,
        exclude_rto_charges: +caseDetails?.exclude_rto_charges === 1 ? 1 : 0,
        rto_charges_remark_type: +caseDetails?.rto_charges_remark_type,
        gst_tds_charges: rtoData?.rtoSyncing?.rcGstTdsCharges,
        net_disbursement_amount: +caseDetails?.actual_disbursed_amt,
      });

      const res = await axios_instance({
        url: "/dts/syncRTOCharges",
        method: "POST",
        data: { reqData },
      });

      const apiResult = decryptRequest(res.data.resData);
      const { status, msg } = apiResult?.result || {};

      if (status) {
        toast.success(msg || "RTO charges synced successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(msg || "Failed to sync RTO charges");
      }
    } catch (err) {
      console.error("Sync failed", err);
      toast.error("Something went wrong while syncing RTO charges");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="col-sm-4 border-dashed-r" id="rto_summary">
        {isLoading ? (
          <ContainerLoading />
        ) : (
          <>
            <h3 className="panel-title">RTO Summary</h3>
            <table className="table" style={{ backgroundColor: "transparent" }}>
              <tbody>
                <tr>
                  <td>
                    <div className="caseTxt">Status</div>
                    <div className="casedetailTxt">
                      {caseDetails.rcSubStatusName}
                    </div>
                  </td>

                  <td>
                    <div className="caseTxt">RTO Agent</div>
                    <div className="casedetailTxt">
                      {caseDetails.rcAgentName ? caseDetails.rcAgentName : "--"}
                    </div>
                  </td>

                  <td>
                    <div className="caseTxt">RTO Name</div>
                    <div className="casedetailTxt">
                      {rtoData.rtoDetails.rto_name}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="caseTxt">Original Doc Collected</div>
                    <div className="casedetailTxt rto-summary-casedetailtxt">
                      {docCollected}
                      {rtoData.rcmHtml ? (
                        <>
                          <button
                            className="ic_info rcm-issue-button"
                            title="RC Transfer Status"
                            onClick={toggleDocPopup}
                            ref={ref}
                          >
                            <img
                              src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                              alt=""
                            />
                            {rtoData.toggleDocPopup ? (
                              <span
                                className="popup-container"
                                dangerouslySetInnerHTML={{
                                  __html: rtoData.rcmHtml,
                                }}
                              ></span>
                            ) : (
                              ""
                            )}
                          </button>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="caseTxt">NAP</div>
                    <div className="casedetailTxt">
                      {typeof rtoData.rtoCharges.extra_nap === "number" ? (
                        <RSpan />
                      ) : (
                        ""
                      )}
                      {typeof rtoData.rtoCharges.extra_nap === "number"
                        ? formatAmount(rtoData.rtoCharges.extra_nap)
                        : "--"}
                    </div>
                  </td>
                  <td>
                    <div className="caseTxt">Total Charges</div>
                    <ClickAwayListener
                      onClickAway={() => {
                        setRtoChargeState({
                          ...rtoChargeState,
                          showRtoChargeModal: false,
                        });
                      }}
                    >
                      <div
                        className={`casedetailTxt ${
                          +rtoData.rtoCharges.total_charges !==
                          +caseDetails.rc_transfer_amount
                            ? "redTxt"
                            : ""
                        }`}
                      >
                        {rtoData.rtoCharges.total_charges ? (
                          <>
                            <RSpan />
                            {formatAmount(rtoData.rtoCharges.total_charges)}

                            <button
                              className="ic_info rtoDetails-button"
                              title="Total RTO Charges"
                              onClick={() =>
                                openClickAwayListener(
                                  "showRtoChargeModal",
                                  "rtoDetails-button",
                                )
                              }
                              disabled={detailsStore.formLoading}
                            >
                              <img
                                src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                                alt=""
                              />
                            </button>
                          </>
                        ) : (
                          "--"
                        )}
                        {rtoChargeState.showRtoChargeModal && (
                          <Portal>
                            <RTOCharges
                              rtoCharges={rtoData.rtoCharges}
                              leftPosition={rtoChargeState.leftPosition}
                              topPosition={rtoChargeState.topPosition}
                            ></RTOCharges>
                          </Portal>
                        )}
                      </div>
                    </ClickAwayListener>
                    {rtoData?.rtoSyncing?.status && (
                      <button
                        type="button"
                        className="btn btn-success btn-sm ml-2"
                        onClick={handleRTOChargeSync}
                        disabled={isLoading}
                      >
                        {isLoading ? "Syncing..." : "Sync"}
                      </button>
                    )}
                  </td>
                  <td className="text-right"></td>
                </tr>
              </tbody>
            </table>
          </>
        )}
      </div>
    </>
  );
};

export default RTOSummary;
